// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tablist[data-v-17e3daac]{display:flex;margin-bottom:1rem;padding-left:0}@media screen and (max-width:32em){.tablist[data-v-17e3daac]{flex-direction:column;margin-left:.5rem}}.tablist>button[data-v-17e3daac]{margin-right:.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
